import { useDriverManagement } from '@/api/useDriverManagement'
import { Horizontal } from '@gravitate-js/excalibrr'
import { Drawer, Spin } from 'antd'
import { DriverAdmin } from './Form/DriverAdmin'
interface AddDriverDrawerProps {
  isVisible: boolean
  onClose: () => void
}

function DriverFormWrapper({ onClose }: { onClose: () => void }) {
  const { useDriverMetadata } = useDriverManagement()
  const { data, isLoading } = useDriverMetadata()

  if (isLoading)
    return (
      <Horizontal fullHeight verticalCenter horizontalCenter>
        <Spin />
      </Horizontal>
    )

  return (
    <DriverAdmin
      metadata={data}
      payConfigNames={undefined}
      selectedDriver={undefined}
      reloadData={() => {}}
      creatingDriver
      setSelectedDriver={() => {}}
      setCreatingDriver={onClose}
      editing
      setEditing={() => {}}
      setLoading={() => {}}
    />
  )
}

function AddDriverDrawer({ onClose, isVisible }: AddDriverDrawerProps) {
  return (
    <Drawer
      title='Create New Driver'
      placement='bottom'
      height='95vh'
      styles={{ body: { padding: 0, minWidth: 1400 } }}
      onClose={onClose}
      open={isVisible}
      destroyOnClose
    >
      <DriverFormWrapper onClose={onClose} />
    </Drawer>
  )
}

// Make sure to export as both a named export and a default export
export { AddDriverDrawer }
export default AddDriverDrawer
